/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Avatar, CircularProgress, Dialog, DialogTitle, InputAdornment, List, ListItem, ListItemAvatar, ListItemIcon, ListItemText, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { SlFolderAlt } from 'react-icons/sl';
import { LanguageContext } from '../../../libs/Context';
import { MdPeopleAlt } from 'react-icons/md';
import { useSelector } from 'react-redux';
import useDebounce from '../../../components/Hooks/useDebounce';
import { queryParams } from '../../../libs/HelperContent';
import { getSharedCompaniesList } from '../../actions/folder_action';
import ShareMenuItem from './ShareMenuItem';
import Loading from '../../../components/Common/Loaders/FullWidthLoader/Loading';
import { toast } from 'react-toastify';
import { getConnectionRelationData } from '../../actions/new_connections_action';
import useIntersectionObserver from '../../../libs/CustomHooks/useIntersectionObserver';

const ShareFilePopup = (props) =>
{
	const { closeShare, shareFiles, shareToggle, setShareData } = props;
	const { language } = useContext(LanguageContext);
	const session:any = useSelector((state:any) => state?.mysession?.session);

	const queryParamRes = queryParams(session?.userId, session?.companyId, session?.empRole, session?.role, 'get');

	const [ shareState, setShareState ] = useState<any>({
		search          : '',
		relationsList   : [],
		relationMembers : [],
		relationsLoader : true,
		skip            : 0,
		itemsPerPage    : 5
	});
	const initialRef = useRef(false);
	const itemsPerPage = 15;

	const observerRef = useRef(null);

	const debounceSearchTerm = useDebounce(shareState?.search, 500);
	const loaderRef = useRef<any>(false);
	const lastEleRef = useRef<any>();
	const [ page, setPage ] = useState<number>(0);
	const [ count, setCount ] = useState<number>(0);
	const LoadMoreList = useIntersectionObserver({ lastEleRef, loaderRef, count, data: shareState?.relationMembers, setPage });

	const fetchParentRelations = async () =>
	{
		try
		{
			const query:any = {
				limit   : 10,
				uid     : session?.userId,
				comid   : session?.companyId,
				empRole : session?.empRole,
				role    : session?.role
			};

			const res = await getConnectionRelationData(query);

			setShareState((prev:any) => ({ ...prev, relationsLoader: true }));

			if (res?.status)
			{
				setShareState((prev:any) => ({ ...prev,
					relationList    : res?.data,
					relationsLoader : false }));
			}
			else
			{
				setShareState((prev:any) => ({ ...prev,
					relationList    : [],
					relationsLoader : false }));
			}
		}
		catch (error:any)
		{
			setShareState((prev:any) => ({ ...prev,
				relationList    : [],
				relationsLoader : false }));
			toast.error(error?.response?.data?.error, {
				position : toast.POSITION.TOP_RIGHT
			});
		}
	};

	const getSearchMemCount = async (query) =>
	{
		try
		{
			const queryR = `${query}&count=true`;

			const res = await getSharedCompaniesList(queryR);

			if (res?.status)
			{
				setCount(res?.count);
			}
		}
		catch (err)
		{
			console.log('---------------', err);
		}
	};

	const fetchCompaniesList = async () =>
	{
		try
		{
			const query = `?${shareState.search ? `search=${shareState?.search}` : 'type=list'}&id=${shareFiles?.data?.folderId}&limit=${itemsPerPage}&skip=${page}${queryParamRes}`;
			const res = await getSharedCompaniesList(query);

			if (res?.status)
			{
				if (!initialRef.current)
				{
					initialRef.current = true;
				}

				page === 0
					? setShareState((prev:any) => ({ ...prev,
						relationMembers : res?.data,
						relationsLoader : false }))
					: setShareState((prev: any) => ({
						...prev,
						relationMembers : [ ...(prev?.relationMembers || []), ...res?.data ],
						relationsLoader : false
					}));

				if (page === 0)
				{
					res?.data?.length >= 15 ? getSearchMemCount(query) : setCount(res?.data?.length);
				}
			}
			else
			{
				setShareState((prev:any) => ({ ...prev,
					relationMembers : [],
					relationsLoader : false }));
			}
			loaderRef.current = false;
		}
		catch (error:any)
		{
			setShareState((prev) => ({ ...prev, relationMembers: [], relationsLoader: false }));
			toast.error(error?.response?.data?.error, {
				position : toast.POSITION.TOP_RIGHT
			});
			loaderRef.current = false;
		}
	};

	const handleSearch = (e) =>
	{
		page !== 0 && setPage(0);

		setShareState((prev:any) => ({
			...prev,
			search       : e.target.value.replace(/^\s+/, ''),
			relationList : []
		}));
	};

	const updateShareData = (data) =>
	{
		setShareData(data);
	};

	useEffect(() =>
	{
		fetchCompaniesList();
	}, [ page ]);

	useEffect(() =>
	{
		LoadMoreList();
	}, [ lastEleRef, count, shareState?.relationMembers ]);

	useEffect(() =>
	{
		fetchCompaniesList();
		if (shareState?.search === '')
		{
			if (session?.empRole !== 'employee')
			{
				fetchParentRelations();
			}
		}
	}, [ debounceSearchTerm ]);

	const renderContent = () =>
	{
		if (!shareState?.relationsLoader && shareState?.search !== '' && shareState?.relationMembers?.length === 0)
		{
			return (<div className='flexRow alignCntr justifyCntr pdngVSM'>
				<span>{language.nodataFound}</span>
			</div>);
		}

		return (
			<div className='flexMinHeightCol scrollY rmvPdng pdngHXXS'>
				<List>

					{shareState?.relationMembers?.map((each:any, ind:number) => (
						<>
							<ListItem key={each?.userId || each?.id || ind} ref={observerRef}> {/* added key for resetting the component when key is changed*/}
								<ListItemAvatar>
									<Avatar>
										<img id='company_profile' src={each?.profileImage || each?.thumbnailImage || '/images/icons/defaultUser.svg'} alt={language.companylogo}/>
									</Avatar>
								</ListItemAvatar>
								<ListItemText primary={each?.name ? each?.name : each?.companyName ? each?.companyName : '---'} secondary={each?.type ? each?.type : '---'}/>
								<ShareMenuItem eachRelationMember={each} eachRelation={undefined} shareFiles={shareFiles} type='relationMember'
									updateShareData={updateShareData}
								/>
							</ListItem>
							{ind === (shareState?.relationMembers?.length - 3) && <span ref={lastEleRef}/>}
						</>
					))}
					{loaderRef.current &&
					<div className='flexRow alignCntr justifyCntr' style={{ minHeight: '100px' }}>
						<CircularProgress />
					</div>}

				</List>
			</div>
		);
	};

	return (

		<Dialog open fullWidth maxWidth='md'>
			<DialogTitle>
				<div className='flexRow brdrBSM alignCntr pdngBXS'>
					<div className='flexAutoRow'>
						<SlFolderAlt className='mrgnRSM' />
					</div>
					<div className='flexMinWidthRow'>
						<span className='subHeadingSM fontWeight'>{language?.share}</span>
						<span className='subHeadingSM ellipsisTxt pdngHSM'>&quot;{shareFiles?.data?.name}&quot;</span>
					</div>
					<button
						tabIndex={0}
						onKeyUp={(e) => { e.key === 'Enter' && closeShare(); }}
						className='flexAutoRow pointer' onClick={closeShare}
					>
						<CloseIcon />
					</button>
				</div>
			</DialogTitle>
			<div className='flexRow pdngHLG alignCntr'>
				<TextField
					fullWidth
					variant='outlined'
					type='search'
					size='small'
					className='whiteBg'
					value={shareState?.search}
					onChange={handleSearch}

					placeholder={language?.searchByNameComompany}
					InputProps={{
						startAdornment : (
							<InputAdornment position='start'>
								<SearchIcon />
							</InputAdornment>
						)
					}}
				/>
			</div>
			{shareState?.relationsLoader && <Loading/>}
			{/* MAPPING FROM HERE, FOR COMPANY INTERNAL EMPLOYEES AND RELATIONS */}
			{session?.empRole === 'employee' &&
			<List>
				<ListItem>
					<ListItemIcon sx={{ minWidth: 'var(--pixel32)' }}>
						<MdPeopleAlt fontSize={'var(--pixel22)'}/>
					</ListItemIcon>
					<ListItemText primary='Company internal employees'/>
					<ShareMenuItem eachRelation={session} eachRelationMember={undefined} shareFiles={shareFiles} type='relation'
						updateShareData={updateShareData}
					/>
				</ListItem>
			</List>}
			<List>
				{shareState?.relationList?.map((each:any, ind) => (
					<div className='pdngHXS' key={each?.relationId || ind}>
						<ListItem>
							<ListItemIcon sx={{ minWidth: 'var(--pixel32)' }}>
								<MdPeopleAlt fontSize={'var(--pixel22)'}/>
							</ListItemIcon>
							<ListItemText primary={each?.relation}/>
							<ShareMenuItem eachRelation={each} eachRelationMember={undefined} shareFiles={shareFiles} type='relation'
								updateShareData={updateShareData}
							/>
						</ListItem>
					</div>
				))}
			</List>
			{/* MAPPING FOR SEARCHED COMPANY WITH PROFILE IMAGE AND THE ACCESS MENU ITEM ALSO GIVEN HERE*/}
			{renderContent()}
		</Dialog>
	);
};

export default ShareFilePopup;